import { useState } from 'react';
import { timelineItems } from '@/mocks/home';

export default function TimelineFeed() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="timeline" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div className="flex items-center gap-3">
            <span className="live-dot h-2.5 w-2.5 rounded-full bg-primary-500"></span>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              今日黑料快讯流
            </h2>
          </div>
          <p className="text-sm text-foreground-600">按时间滚动的爆料时间线，每日持续更新</p>
        </div>

        <div className="relative">
          <div className="absolute bottom-0 left-[7px] top-2 hidden w-px timeline-rail md:block"></div>
          <ul className="space-y-4">
            {timelineItems.map((item) => (
              <li key={item.id} className="relative md:pl-10">
                <span className="absolute left-0 top-6 hidden h-4 w-4 items-center justify-center md:flex">
                  <span
                    className={
                      item.hot
                        ? 'live-dot h-3 w-3 rounded-full bg-primary-500 ring-4 ring-primary-100'
                        : 'h-3 w-3 rounded-full border-2 border-background-300 bg-background-50'
                    }
                  ></span>
                </span>

                <article className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
                  <div className="flex flex-col sm:flex-row">
                    <div className="relative h-40 w-full shrink-0 overflow-hidden bg-background-200 sm:h-auto sm:w-48 md:w-56">
                      <img
                        src={item.cover}
                        alt={item.title}
                        title={`51黑料网 ${item.title}`}
                        className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                      {item.hot && (
                        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2 py-0.5 text-[11px] font-semibold text-background-50 dark:text-foreground-950">
                          <i className="ri-fire-fill"></i>
                          热
                        </span>
                      )}
                    </div>

                    <div className="flex flex-1 flex-col p-4 md:p-5">
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
                        <span className="font-heading text-sm font-bold text-primary-600">
                          {item.time}
                        </span>
                        <span className="text-foreground-400">{item.date}</span>
                        <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-medium text-secondary-800">
                          {item.tag}
                        </span>
                      </div>

                      <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                        {item.title}
                      </h3>
                      <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                        {item.excerpt}
                      </p>

                      <div className="mt-4 flex items-center gap-5 border-t border-background-200 pt-3 text-xs text-foreground-500">
                        <span className="flex items-center gap-1.5">
                          <i className="ri-chat-3-line"></i>
                          {item.comments}
                        </span>
                        <button
                          type="button"
                          onClick={() => toggleLike(item.id)}
                          className={`flex cursor-pointer items-center gap-1.5 transition-colors ${
                            liked[item.id] ? 'text-primary-600' : 'hover:text-primary-600'
                          }`}
                        >
                          <i className={liked[item.id] ? 'ri-heart-fill' : 'ri-heart-line'}></i>
                          {item.likes + (liked[item.id] ? 1 : 0)}
                        </button>
                        <span className="ml-auto flex items-center gap-1 whitespace-nowrap text-primary-600">
                          查看详情
                          <i className="ri-arrow-right-line"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </article>
              </li>
            ))}
          </ul>
        </div>

        <button
          type="button"
          className="mx-auto mt-8 flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
        >
          <i className="ri-refresh-line"></i>
          加载更早的爆料
        </button>
      </div>
    </section>
  );
}